import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const deleteObstructionMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Delete Obstruction',
		isVisible: ({ controller, refMap }): boolean => {
			const { obstruction } = refMap ?? {};
			if (controller.readonly || !obstruction) return false;

			return obstruction.connections.children.length <= 1;
		},
		onClick: ({ controller, refMap }): void => {
			const obstruction = refMap?.obstruction ?? null;
			const obstructions = controller?.kitchen?.design.obstructions ?? null;

			if (obstructions && obstruction) obstructions.delete(obstruction.id);
		}
	}
};
